"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUTO_LINE_URL = exports.DUMMY_HISTORY_STATE = void 0;
var mobx_1 = require("mobx");
var telephone_estimatable_store_ranking_modal_1 = __importDefault(require("@hikakaku/shared/components/estimate_form/telephone_estimatable_store_ranking_modal"));
var google_analytics_manager_1 = __importDefault(require("@hikakaku/shared/util/google_analytics_manager"));
exports.DUMMY_HISTORY_STATE = 'DUMMY_HISTORY_STATE';
exports.AUTO_LINE_URL = 'https://autoline.link/hikakaku/apis/line_login_link';
var TelephoneEstimatableStoreRankingModalStore = /** @class */ (function () {
    function TelephoneEstimatableStoreRankingModalStore(props) {
        var _this = this;
        this.component = telephone_estimatable_store_ranking_modal_1.default;
        this.isOpen = false;
        this.handleClickLineAddFriend = function () {
            google_analytics_manager_1.default.postGAEvent('LINE友達追加', 'click', _this.lineAddFriendGaEventLabel);
            window.open("".concat(exports.AUTO_LINE_URL, "?register_from=lineAddFriend+estimate_form"), '_blank');
        };
        this.handleClose = function () {
            _this.isOpen = false;
        };
        this.handlePopState = function (event) {
            if (event.state === exports.DUMMY_HISTORY_STATE) {
                _this.isOpen = true;
            }
        };
        this.handleClickLeavePage = function () {
            window.history.back();
        };
        this.rankingStores = props.rankingStores;
        this.lineAddFriendGaEventLabel = props.lineAddFriendGaEventLabel;
    }
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], TelephoneEstimatableStoreRankingModalStore.prototype, "isOpen", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], TelephoneEstimatableStoreRankingModalStore.prototype, "handleClickLineAddFriend", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], TelephoneEstimatableStoreRankingModalStore.prototype, "handleClose", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], TelephoneEstimatableStoreRankingModalStore.prototype, "handlePopState", void 0);
    return TelephoneEstimatableStoreRankingModalStore;
}());
exports.default = TelephoneEstimatableStoreRankingModalStore;
